import { UserStatus } from '../../model/dto/user-status.enum';
import { StatusTone } from '../../model/type/status-tone.type';
import { ListSortOption } from '../../model/ui/list-sort-option';
import { UserInfo } from '../../model/dto/user-info';

const ACCOUNT_DEACTIVATED = '[ACCOUNT DEACTIVATED]';

export const isDeactivatedAccount = ({
  first_name,
  last_name,
  email,
}: UserInfo): boolean =>
  first_name === ACCOUNT_DEACTIVATED &&
  last_name === ACCOUNT_DEACTIVATED &&
  email === ACCOUNT_DEACTIVATED;

export const getUserDisplayName = ({
  first_name,
  last_name,
}: UserInfo): string => {
  if (first_name === ACCOUNT_DEACTIVATED || last_name === ACCOUNT_DEACTIVATED) {
    return ACCOUNT_DEACTIVATED;
  }

  return [first_name, last_name].filter(Boolean).join(' ') || '-';
};

export const getUserStatusTone = (status?: UserStatus): StatusTone => {
  switch (status) {
    case UserStatus.Active:
      return 'success';

    case UserStatus.WaitingForApproval:
    case UserStatus.WaitingForRegistration:
      return 'pending';

    case UserStatus.DemoAccount:
      return 'progress';

    case UserStatus.Deactivated:
    case undefined:
      return 'neutral';

    default: {
      const unhandledStatus: never = status;

      return unhandledStatus;
    }
  }
};

export const getUserListSortOptions = (
  translate: (key: string) => string
): ListSortOption[] => [
  {
    order_by: 'registration_date',
    order_dir: 'desc',
    label: translate('userList.sortOptions.registeredNewest'),
  },
  {
    order_by: 'registration_date',
    order_dir: 'asc',
    label: translate('userList.sortOptions.registeredOldest'),
  },
  {
    order_by: 'latest_scan_date',
    order_dir: 'desc',
    label: translate('userList.sortOptions.latestScanNewest'),
  },
  {
    order_by: 'latest_scan_date',
    order_dir: 'asc',
    label: translate('userList.sortOptions.latestScanOldest'),
  },
  {
    order_by: 'first_name',
    order_dir: 'asc',
    label: translate('userList.sortOptions.nameAscending'),
  },
  {
    order_by: 'first_name',
    order_dir: 'desc',
    label: translate('userList.sortOptions.nameDescending'),
  },
  {
    order_by: 'email',
    order_dir: 'asc',
    label: translate('userList.sortOptions.emailAscending'),
  },
  {
    order_by: 'email',
    order_dir: 'desc',
    label: translate('userList.sortOptions.emailDescending'),
  },
];
